import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';
import pb from '../../../lib/pocketbase';

const emptyForm = {
  company_name: '',
  address: '',
  email: '',
  phone: '',
  hours: '',
  google_maps_url: '',
  social_links_json: '[]',
};

function safeJsonParse(str, fallback) {
  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
}

function AdminSiteContactSettingsPage() {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [recordId, setRecordId] = React.useState('');
  const [form, setForm] = React.useState(emptyForm);

  const fetchSettings = async () => {
    setError('');
    try {
      const res = await pb.collection('site_contact_settings').getList(1, 1, { sort: '-created' });
      const it = res?.items?.[0] || null;
      if (!it) {
        setRecordId('');
        setForm(emptyForm);
        return;
      }
      setRecordId(it.id);
      setForm({
        company_name: it.company_name || '',
        address: it.address || '',
        email: it.email || '',
        phone: it.phone || '',
        hours: it.hours || '',
        google_maps_url: it.google_maps_url || '',
        social_links_json: JSON.stringify(it.social_links ?? [], null, 2),
      });
    } catch (e) {
      setError(e?.message || 'Erreur chargement des réglages');
    }
  };

  React.useEffect(() => {
    fetchSettings();
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      const payload = {
        company_name: form.company_name || '',
        address: form.address || '',
        email: form.email || '',
        phone: form.phone || '',
        hours: form.hours || '',
        google_maps_url: form.google_maps_url || '',
        social_links: safeJsonParse(form.social_links_json, []),
      };

      if (recordId) {
        await pb.collection('site_contact_settings').update(recordId, payload);
      } else {
        const created = await pb.collection('site_contact_settings').create(payload);
        setRecordId(created?.id || '');
      }

      await fetchSettings();
      alert('Enregistré');
    } catch (e) {
      alert(e?.message || "Erreur d'enregistrement");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Contact · Réglages</h1>
      <p>Ces infos seront utilisées sur la page contact (adresse, téléphone, horaires, etc.).</p>

      <style>{`
        .field{ display:flex; flex-direction:column; gap:6px; margin-top: 10px; }
        .field label{ font-size:.9rem; color: var(--admin-muted); }
        .field input, .field textarea{
          background: var(--admin-panel-2);
          border:1px solid var(--admin-border);
          color: var(--admin-text);
          border-radius:10px;
          padding:10px 10px;
          outline:none;
        }
        .field textarea{ min-height: 140px; resize: vertical; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
        .field input:focus, .field textarea:focus{ border-color: var(--admin-accent); box-shadow: 0 0 0 3px rgba(79,70,229,0.20); }
        .btn{ cursor:pointer; border:1px solid var(--admin-border); background: transparent; color: var(--admin-text); padding: 10px 12px; border-radius: 10px; }
        .btn:hover{ background: rgba(255,255,255,0.06); }
        .admin-shell.admin-light .btn:hover{ background: rgba(2,6,23,0.06); }
        .btn-solid{ border-color: rgba(79,70,229,0.6); background: linear-gradient(135deg, var(--admin-accent), rgba(79,70,229,0.85)); color:#fff; }
        .btn-solid:disabled{ opacity: .6; cursor: not-allowed; }
      `}</style>

      {error && <div style={{ color: '#ef4444', marginBottom: 8 }}>{error}</div>}

      <div className="card" style={{ marginTop: 12 }}>
        <div className="field">
          <label>Nom de l'entreprise</label>
          <input value={form.company_name} onChange={(e) => setForm(f => ({ ...f, company_name: e.target.value }))} />
        </div>
        <div className="field">
          <label>Adresse</label>
          <input value={form.address} onChange={(e) => setForm(f => ({ ...f, address: e.target.value }))} />
        </div>
        <div className="field">
          <label>Email</label>
          <input value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} />
        </div>
        <div className="field">
          <label>Téléphone</label>
          <input value={form.phone} onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))} />
        </div>
        <div className="field">
          <label>Horaires</label>
          <input value={form.hours} onChange={(e) => setForm(f => ({ ...f, hours: e.target.value }))} />
        </div>
        <div className="field">
          <label>Google Maps URL</label>
          <input value={form.google_maps_url} onChange={(e) => setForm(f => ({ ...f, google_maps_url: e.target.value }))} />
        </div>
        <div className="field">
          <label>Social links (JSON)</label>
          <textarea value={form.social_links_json} onChange={(e) => setForm(f => ({ ...f, social_links_json: e.target.value }))} />
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
          <button className="btn" onClick={fetchSettings} disabled={loading}>Recharger</button>
          <button className="btn btn-solid" onClick={handleSave} disabled={loading}>{loading ? 'Enregistrement…' : 'Enregistrer'}</button>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminSiteContactSettingsPage;
